import { createStore } from 'state-pool';

const approvalStore = createStore();

approvalStore.setState('selectedApprovalRowIndex', null);

export default approvalStore;
